export function getPostAuthRedirectPath({
  isRegistration = false,
  nextPath = "",
} = {}) {
  if (isRegistration) return "/registration/onboarding";

  if (
    typeof nextPath === "string" &&
    nextPath.startsWith("/") &&
    !nextPath.startsWith("//")
  ) {
    return nextPath;
  }

  return "/events/search";
}
